var React = require('react');

function IconNewsSolidO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M944.4 65.1H80.1c-8.9 0-16 7.1-16 16.1L63.6 958 254 766.6h690.5c8.8 0 16-7.2 16-16V81.1c-.1-8.9-7.3-16-16.1-16zm-46.4 621c0 8.8-7.2 16-16 16H227.5l-99.4 101.4.4-658.8c0-9 7.2-16.1 16-16.1h737.3c8.8 0 16 7.2 16 16v541.5h.2z","key":0}),React.createElement("path",{"d":"M378.5 465.7h-89.7V376h89.7v89.7zm179.3 0h-89.7V376h89.7v89.7zm179.4 0h-89.7V376h89.7v89.7z","key":1})]);
}

IconNewsSolidO.displayName = "IconNewsSolidO";

IconNewsSolidO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconNewsSolidO;

IconNewsSolidO.default = IconNewsSolidO;
